@if (showField$ | async) {
  <mat-form-field [floatLabel]="field.floatLabel || 'auto'">
    <!-- <input matInput [matDatepickerFilter]="myFilter" [matDatepicker]="picker" placeholder="Choose a date"> -->
    <mat-label>{{(field.label | translate) || ""}}</mat-label>
    <input matInput
      [required]="!!field.validators?.required"
      [matDatepicker]="picker"
      [matDatepickerFilter]="field.filter"
      [formControl]="$any(field.control)"
      [placeholder]="field.placeholder"
      >
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
